import type { PinCode_bool_exp, PinCodeTableFragment } from '../../graphql/hasura/generated';
import Model from '../Model';

export const PinCodeModel = new Model<
  PinCode_bool_exp,
  PinCodeTableFragment
>({
  names: {
    schemaName: 'PinCode',
    displayName: 'Property PIN Code',
    pluralDisplayName: 'Property PIN Codes',
  },

  permissionsOptions: {
    // Do not allow direct deletion of SGT and Temporary Guest PIN Codes.
    // Their associated user roles should be revoked instead (which will trigger deletion).
    canDeleteRow: (args, { userRoleId }) => !userRoleId,
  },
});

export default PinCodeModel;
